import BudgetReconciliationBillAlert from 'tio-employee/components/budget-reconciliation-bill-alert';
import { t } from 'ember-intl';
import { VStack, Header } from 'tio-ui/components/layout';
import pageTitle from 'ember-page-title/helpers/page-title';

<template>
  {{pageTitle "PSLF" prepend=false}}
  <VStack>
    <BudgetReconciliationBillAlert />
    <Header>{{t "pslf.default_full"}}</Header>
    {{outlet}}
  </VStack>
</template>
